import {
  RtbCampaignBasicFormModel,
  RtbCampaignBasicFormModelConstructorParams
} from './RtbCampaignBasicFormModel';
import { AdType } from 'core/rtbCampaign/RtbCampaign';
import { AbstractOutdoorCampaignFormModel } from './OutdoorCampaignFormModel';
import {
  DEFAULT_INVENTORY,
  LimitationInventorySettings
} from 'containers/Limitations/LimitationSetting/limitationConfig/limitationSettingsType';
import { OPERATE } from 'enum/Operate';
import { defaultItemSetting } from 'components/CampaignLimitation/SelectItemComponent';
import { SelectComponent } from 'components/CampaignLimitation/SelectComponent';
import i18n from 'i18n';
import { CustomGeofenceComponent } from 'components/CampaignLimitation/CustomGeofenceComponent';
import { getCustomGeofenceLabel } from 'utils/LimitationUtil';
import { PublisherCustomInputComponentModel } from 'components/CampaignLimitation';
import { LimitationData } from 'core/limitation/Limitation';

export interface SandboxMovableOutdoorFormModel extends RtbCampaignBasicFormModel {
  readonly canEditBudgetPlan: boolean;
  readonly canEditPriceModel: boolean;
}

abstract class AbstractSandboxMovableOutdoorFormModel
  extends AbstractOutdoorCampaignFormModel
  implements SandboxMovableOutdoorFormModel
{
  override get campaignAdType(): AdType {
    return AdType.SANDBOX_MOVABLE_OUTDOOR;
  }

  override getDefaultLimitations(): LimitationData {
    return {
      include: [],
      exclude: [],
      preferred: [],
      nonPreferred: [],
      other: [
        {
          op: 'inc',
          type: 'dealId',
          value: [{ label: 'demo_space', value: 'demo_space' }]
        }
      ]
    };
  }

  override getLimitationInventorySetting(_1: {
    [key: string]: string[];
  }): LimitationInventorySettings[] {
    return [
      {
        name: DEFAULT_INVENTORY
      },
      {
        name: 'publisher',
        title: 'limitation.labels.publisher',
        singleSelect: false,
        ignoreValidateOption: true,
        supportOperates: [OPERATE.INCLUDE, OPERATE.EXCLUDE],
        itemSetting: defaultItemSetting(),
        searchPlaceholder: '',
        ignoreAddonFeature: true,
        component: SelectComponent,
        customInputModelGetter: () => new PublisherCustomInputComponentModel(),
        cb: async () => []
      },
      {
        name: 'customGeofence',
        title: 'limitation.labels.customGeofence',
        singleSelect: false,
        ignoreValidateOption: true,
        supportOperates: [
          OPERATE.INCLUDE,
          OPERATE.EXCLUDE,
          OPERATE.PREFERRED,
          OPERATE.NONPREFERRED
        ],
        itemSetting: defaultItemSetting(),
        searchPlaceholder: '',
        ignoreAddonFeature: true,
        formatter: (value: string | number) => {
          return getCustomGeofenceLabel(value.toString());
        },
        component: CustomGeofenceComponent
      },
      {
        name: 'geofence',
        title: 'limitation.labels.geofence',
        singleSelect: false,
        ignoreValidateOption: true,
        supportOperates: [
          OPERATE.INCLUDE,
          OPERATE.EXCLUDE,
          OPERATE.PREFERRED,
          OPERATE.NONPREFERRED
        ],
        itemSetting: defaultItemSetting(),
        searchPlaceholder: 'limitation.placeholders.searchGeofence',
        ignoreAddonFeature: true,
        component: SelectComponent,
        cb: async () => [
          {
            label: i18n.t('limitation.locations.xiangshanStation'),
            value: '25.0327953, 121.5690180,1'
          },
          {
            label: i18n.t('limitation.locations.daanStation'),
            value: '25.0331511, 121.5434750,1'
          },
          {
            label: i18n.t('limitation.locations.nanjingFuxingStation'),
            value: '25.0522533, 121.5439767,1'
          },
          {
            label: i18n.t('limitation.locations.songshanStation'),
            value: '25.0499487, 121.57747,1'
          },
          {
            label: i18n.t('limitation.locations.yonganMarketStation'),
            value: '25.002326419017887, 121.51109147208673,1'
          },
          {
            label: i18n.t('limitation.locations.shilinStation'),
            value: '25.09351276144409, 121.52611598275493,1'
          },
          {
            label: i18n.t('limitation.locations.tamsuiStation'),
            value: '25.167708816359923, 121.4456889118904,1'
          },
          {
            label: i18n.t(
              'limitation.locations.taipeiNangangExhibitionCenterStation'
            ),
            value: '25.055292179543432, 121.61867510431571,1'
          },
          {
            label: i18n.t('limitation.locations.taipeiMainStation'),
            value: '25.049597811481995, 121.51394524908939,1'
          },
          {
            label: i18n.t('limitation.locations.wanfangHospitalStation'),
            value: '24.999490042691686, 121.55794386342562,1'
          },
          {
            label: i18n.t('limitation.locations.ximenStation'),
            value: '25.042226701290165, 121.50876077629705,1'
          },
          {
            label: i18n.t('limitation.locations.minquanWestRoadStation'),
            value: '25.062889168611754, 121.5204839558327,1'
          },
          {
            label: i18n.t('limitation.locations.luzhouStation'),
            value: '25.0917660798662, 121.46369054733672,1'
          },
          {
            label: i18n.t('limitation.locations.fuJenUniversityStation'),
            value: '25.032917778157817, 121.43501958896063,1'
          },
          {
            label: i18n.t('limitation.locations.shanbStation'),
            value: '25.080820, 121.28560, 1'
          },
          {
            label: '騰學',
            value: '25.0262182, 121.5534931,1'
          },
          {
            label: '頤曜',
            value: '25.0439054, 121.2956103,1'
          }
        ]
      }
    ];
  }
}

export class EditSandboxMovableOutdoorFormModel extends AbstractSandboxMovableOutdoorFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('edit', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return false;
  }
  get canEditPriceModel(): boolean {
    return false;
  }
  canEditOptimize(): boolean {
    return false;
  }
}

export class CreateSandboxMovableOutdoorFormModel extends AbstractSandboxMovableOutdoorFormModel {
  constructor(...args: RtbCampaignBasicFormModelConstructorParams) {
    super('create', ...args);
  }
  get canEditBudgetPlan(): boolean {
    return true;
  }
  get canEditPriceModel(): boolean {
    return true;
  }
}
